import clsx from 'clsx'

import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs'
import { useLocale } from 'src/contexts/LocaleContext'
import { generateBreadcrumbs } from 'src/functions/util/generateBreadcrumbs'

import styles from './ProductBreadCrumbs.module.scss'

import type { Collection } from 'src/data/graphql-generated'

interface ProductBreadCrumbsProps {
  breadcrumbs: (Collection | undefined)[]
  hidden?: 'desktop' | 'mobile'
}

export const ProductBreadCrumbs = ({ breadcrumbs, hidden }: ProductBreadCrumbsProps) => {
  const { language } = useLocale()

  const generatedBreadcrumbs = generateBreadcrumbs(breadcrumbs, language)

  return (
    <div
      className={clsx({
        [styles.container]: true,
        [styles.hiddenDesktop]: hidden === 'desktop',
        [styles.hiddenMobile]: hidden === 'mobile',
      })}
    >
      <Breadcrumbs items={generatedBreadcrumbs} />
    </div>
  )
}
